import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';

type CreateCurriculumSectionProps = {
  children: React.ReactNode;
  title?: string;
};

export const CreateCurriculumSection = ({ children, title }: CreateCurriculumSectionProps) => {
  const { t } = useTranslations();
  return (
    <div className={cn('flex flex-col gap-6 bg-white p-6 md:gap-8 md:rounded-lg md:p-8')}>
      {title && <h3 className="text-2xl font-bold md:text-3xl">{t(title)}</h3>}
      {children}
    </div>
  );
};
